<template>
  <VDialog v-model="isVisible" :retain-focus="false" width="500" persistent attach="#LetsPage">
    <VCard v-if="isVisible">
      <VCardTitle>{{ $t('C40101.AssignBtn.I0kiFL-U9xuE_pVFvARL4') }}</VCardTitle>
      <VCardText v-debug>
        <h3>dialogData</h3>
        {{dialogData}}
      </VCardText>
      <VCardText >
        <span v-if="dialogData.incorrect" style="color: red;">
          {{ $t('C40101.AssignBtn.HVdr1YMBqqfvUhjWPJIHK') }}
        </span>
        <VTextField
          v-model="dialogData.password"
          type="password"
          variant="outlined"
          hide-details
        ></VTextField>
      </VCardText>
      <VCardText v-debug>
        <h3>outputData</h3>
        {{outputData}}
      </VCardText>
      <VCardActions>
        <VSpacer></VSpacer>
        <VBtn
          :disabled="!dialogData.password"
          color="primary"
          @click="checkPassword"
        >
          OK
        </VBtn>
        <VBtn
          v-bind="{
            color: '#AEAEAE',
            style: { color: '#FFFFFF' }
          }"
          @click="emitCancel">{{ $t('common.cancel') }}</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  mixins:[
    DialogMixin
  ],
  data () {
    return {
    }
  },
  methods: {
    ...require('vuex').mapActions("C40101", [
      "C40101_checkPassword"
    ], ),
    async checkPassword() {
      return this.C40101_checkPassword({
        'user_password': this.dialogData.password
      }).then(async (res) => {
        if(res == null){
          this.dialogData.incorrect = true;
        } else {
          this.dialogData.incorrect = false;
          this.outputData ={
            'success': true,
          }
          this.emitOk();
        }
      })
    }
  }
}
</script>

<style>

</style>
